export default "__VITE_ASSET__CwTzNlPE__"